<div class="modal-body">
  <p class="centermodal__title">
    {{ 'documentHistory.fieldsFilledForm.title' | translate }}
  </p>
  <div class="centermodal__message-body centermodal__message-body--margin-normal">
    <p class="centermodal__message">
      {{ 'documentHistory.fieldsFilledForm.description' | translate }}
    </p>

    <div class="fields__container">
      <div class="fields__top">
        <span class="fields__title">{{ 'documents.fields.fields' | translate }}</span>

        <button class="btn-S btn-text icon-start" (click)="copyFilledFieldsValues()">
          <i class="fa-regular fa-clone"></i>
          {{ 'button.copy' | translate }}
        </button>
      </div>

      <div class="fields__box">
        @for (field of signerFieldsData; track $index) {
          <div class="fields__item">
            {{ field.name + ': ' + field.value }}
          </div>
        }
      </div>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
  </div>
</div>
